import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import AttachmentActions, { attachmentActionTypes } from '../actions/attachmentActions';
import AttachmentServices from '../services/attachmentServices';

/**
 * @param action
 */
function* _createAttachment(action) {
  try {
    yield put(AttachmentActions.createAttachmentLoading(true));
    const attachment = yield AttachmentServices.createAttachment(action.payload);
    if (attachment.success) {
      yield put(TrackerActions.trackAction(attachmentActionTypes.CREATE_ATTACHMENT.SUCCESS, attachment.data));
      notification.open({
        type: 'success',
        message: 'Attachment successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(attachment?.data?.[0]);
      yield put(AttachmentActions.createAttachmentLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: 'Error in creating Attachment',
        duration: 4,
        placement: 'top',
      });
      yield put(AttachmentActions.createAttachmentLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(AttachmentActions.createAttachmentLoading(false));
    yield put(TrackerActions.trackAction(attachmentActionTypes.CREATE_ATTACHMENT.ERROR, error));
  }
}

/**
 *
 */
function* createAttachment() {
  yield takeLatest(attachmentActionTypes.CREATE_ATTACHMENT.REQUEST, _createAttachment);
}

/**
 * @param action
 */
function* _updateAttachment(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(AttachmentActions.updateAttachmentLoading(true));
    const attachment = yield AttachmentServices.updateAttachment(payload);
    if (attachment.success) {
      yield put(TrackerActions.trackAction(attachmentActionTypes.UPDATE_ATTACHMENT.SUCCESS, attachment.data));
      notification.open({
        type: 'success',
        message: 'Attachment successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
      yield put(AttachmentActions.updateAttachmentLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: attachment?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(AttachmentActions.updateAttachmentLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(AttachmentActions.updateAttachmentLoading(false));
    yield put(TrackerActions.trackAction(attachmentActionTypes.UPDATE_ATTACHMENT.ERROR, error));
  }
}

/**
 *
 */
function* updateAttachment() {
  yield takeLatest(attachmentActionTypes.UPDATE_ATTACHMENT.REQUEST, _updateAttachment);
}

/**
 * @param action
 */
function* _getAttachmentById(action) {
  try {
    const {
      entityId, entityName, callback,
    } = action;
    yield put(AttachmentActions.getAttachmentByIdLoading(true));

    const selectedAttachment = yield AttachmentServices.getAttachment(entityId, entityName);
    yield put(AttachmentActions.getAttachmentByIdSuccess(selectedAttachment));
    if (callback) {
      callback();
    }
    yield put(AttachmentActions.getAttachmentByIdLoading(false));
  } catch (error) {
    yield put(AttachmentActions.getAttachmentByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(attachmentActionTypes.GET_ATTACHMENT_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getAttachmentById() {
  yield takeLatest(attachmentActionTypes.GET_ATTACHMENT_BY_ID.REQUEST, _getAttachmentById);
}

/**
 * @param action
 */
function* _deleteAttachment(action) {
  try {
    yield put(AttachmentActions.deleteAttachmentLoading(true));
    const attachment = yield AttachmentServices.deleteAttachment(action.payload);

    if (attachment.success) {
      notification.open({
        type: 'success',
        message: 'Attachment successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: attachment?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(AttachmentActions.deleteAttachmentLoading(false));
  } catch (error) {
    yield put(AttachmentActions.deleteAttachmentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(attachmentActionTypes.DELETE_ATTACHMENT.ERROR, error));
  }
}

/**
 *
 */
function* deleteAttachment() {
  yield takeLatest(attachmentActionTypes.DELETE_ATTACHMENT.REQUEST, _deleteAttachment);
}

/**
 *
 */
export default function* attachmentSaga() {
  yield all([
    createAttachment(), updateAttachment(), getAttachmentById(), deleteAttachment(),
  ]);
}
